import { FC, FormEvent, useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { CardRegistrationForm } from "./CardRegisterForm";

export const CommonFooter: FC = () => {
  useEffect(() => {
  }, [])

  function buildLinkTag(href: string, text: string){
    return <div className="mb-2">
      <a href={href} className="text-sm">{text}</a>
    </div>
  }

  return <>
    <div id="footer" className="w-full bg-[#03034F] block text-white pt-10 pb-10">
      <div className="w-full bg-[#03034F] block sm:flex justify-between">
        <div id="footer-left-area" className="ml-10">
          <img src="/images/drop-ai-logo-white.png" alt="logo" className="w-[120px]" />
        </div>
        <div id="footer-right-area" className="block sm:flex mr-20 ml-10 sm:ml-0 mt-6 sm:mt-0 mb-6 sm:mb-0">
          <div className="mr-20">
            {buildLinkTag("/", "Top")}
          </div>
          <div className="mr-12">
            {buildLinkTag("/image-generation", "画像生成")}
            {buildLinkTag("/inspiration", "インスピレーション")}
            {buildLinkTag("/account", "アカウント")}
          </div>
          <div className="mr-20">
            {buildLinkTag("/plan", "プラン")}
            {buildLinkTag("/#faq", "FAQ")}
            {buildLinkTag("/article", "お役立ち情報")}
            {buildLinkTag("/article/news", "NEWS")}
          </div>
          <div>
            {buildLinkTag("/terms-of-service", "利用規約")}
            {buildLinkTag("/privacy-policy", "プライバシーポリシー")}
            {buildLinkTag("/commercial-transactions", "特定商取引法に基づく表示")}
            {buildLinkTag("/about-model", "モデルテイストについて")}
            {buildLinkTag("/company", "運営会社")}
            {buildLinkTag("/contact", "お問い合わせ")}
          </div>
        </div>
      </div>
      <div className="mt-8 block text-xs text-gray-200 mx-auto text-center">GO TO MARKET, inc. All Rights. Reserverd</div>
    </div>
  </>;

}